import { Col, Row } from 'antd';
import { Routes } from 'config/routes';
import { ITabsItem } from 'modules/common/components/CardTabs';
import NavigationCardTabs from 'modules/navigation/components/NavigationCardTabs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import EnterNightlyCountForm from '../EnterNightlyCountForm';
import NightlyCountHistoryTable from '../NightlyCountHistoryTable';

const NightlyCountPageTabs: FC = () => {
  const { t } = useTranslation('nightlyCount.NightlyCountPageTabs');

  const enter: ITabsItem = {
    title: t('enterCount'),
    content: <EnterNightlyCountForm />,
    key: `${Routes.NightlyCountEnter}`,
  };

  const history: ITabsItem = {
    title: t('countHistory'),
    content: <NightlyCountHistoryTable />,
    key: `${Routes.NightlyCountHistory}`,
  };

  return (
    <Row gutter={[0, 10]}>
      <Col span={24}>
        <NavigationCardTabs items={[enter, history]} />
      </Col>
    </Row>
  );
};

export default NightlyCountPageTabs;
